import * as actionTypes from "./actionTypes";

const physicalInventoryReducer = (state = [], payload) => {
  switch (payload.type) {
    case actionTypes.ADD_NEW_PHYSICAL_INVENTORY_SUCCESS:
      return [...payload.captureGoodsResponse];

    case actionTypes.EDIT_PHYSICAL_INVENTORY_SUCCESS:
      return [...payload.captureGoodsResponse];

    case actionTypes.DELETE_PHYSICAL_INVENTORY_SUCCESS:
      return [...payload.captureGoodsResponse];

    default:
      return state;
  }
};

export default physicalInventoryReducer;
